export default {
  result: {
    err: "Order information error.",
    success: "Pay Success",
    paymoney: "Money:",
    yuan: " yuan",
    order: {
      describe: "Payment Information",
      name: "Merchant Name:",
      no: "Order No:",
      paytime: "Payment time:",
    },
    detail: {
      describe: "Detail Information",
      project: "Charge Items:",
      range: "Toll Interval:",
      money: "Amount:",
      remark: "remark info",
    },
    ticket: {
      describe: "Invoice Information",
      title: "Invoice Title:",
      type: "Invoice Type:",
      idtype: "Taxpayer Identification Number:",
      email: "Mailbox:",
    },
  },
  homePage: {
    homepage: "Home Page",
    title: "On-line Payment Platform",
    seeMore: "More..",
    helpCenter: "Help Center",
    login: "Sign In",
    register: "Register",
    welcome: "Welcome, ",
    logout: "Logout",
    userInfo: "Personal Information",
    close: "Close",
    anonymousPayment: "Anonymous Payment",
    forgetPassword: "Forgot password?",
    registerTips: "Don't have an account? Create one now.",
    loginTips: "Already registered? Login now.",
    backhome: "Back to Home Page",
    header: {
      zh: "交费大厅",
      en: "On-line Payment Platform",
    },
    user: {
      code: "User ID",
      name: "Name",
      dept: "Department",
      identify: "Number of Certificate",
      mobilephone: "Phone",
      email: "Email",
      editInfo: "Edit Personal Information",
      save: "Save",
      cancel: "Cancel",
    },
    placeholder: {
      userName: "Enter your name",
      idType: "Please select card type",
      idNum: "Enter your code",
      password: "Enter your password",
      rePassword: "Repeat your password",
      random: "Enter verification code",
      refreshRandom: "Click Refresh verification code",
    },
    options: [
      {
        name: "Payable Payments",
        detail: "Payable payments in 2019 ",
      },
      {
        name: "Optional Payments",
        detail: "Optional payments in 2019",
      },
      {
        name: "Payment Records",
        detail: "Payment records in 2019",
      },
    ],
    footer: ["Platform Introduction", "Payment Guide", "Methods of Payment", "Contant Us"],
  },
  unpaid_fee: {
    charge_card: {
      range: "Range",
      receive: "Current Payable",
      pay: "Amount of Payment",
    },
    sumOfMoney: "Total amount selected: ",
    pay: "Pay",
  },
  pay_situation: {
    download: {
      title: "Download Invoice",
      name: "Fee Item",
      money: "Amount of Payment",
      date: "Date of Payment",
      code: "Invoice Number",
      download: "Download Invoices",
      close: "Close",
      tips: "No downloadable invoices.",
    },
    list: {
      name: "Fee Item",
      range: "Range",
      need_money: "Payables",
      later_money: "Delay",
      receive_money: "Actual Payment Amount",
      operate: "Operation",
      detail: "Details",
      download: "Download Invoice",
      noRange: "no year",
      allRange: "all",
    },
  },
  pay_situation_detail: {
    sum_need_pay: "Current Total Payables",
    sum_already_pay: "Total Amount Paid",
    standard: "Standard Payables",
    discount: "Reduction",
    deduction: "Deduction",
    laterVos: "Delay",
    reditVos: "Loan",
    payTikectVos: "Paid",
    expire: "Expired",
    ticketNum: "Invoice Number",
    nowMoney: "Current Payables",
    close: "Close",
  },
  pay_ticket: {
    ticket_info: "Invoice Information",
    ticket_detail: "Order Details",
    name: "Name",
    code: "Student/Employee ID",
    bussiness_code: "Certificate Number",
    sum: "Total Amount：",
    commit: "Submit",
    add: "Add",
    cancel: "Cancel",
    search: "Search",
    person: "Issue Personal Invoice",
    person_tips: "Part of the fee items can only be invoiced with personal invoice title.",
    person_placeholder: "Input the invoice title.",
    organ: "Issue Enterprise and Organization Invoice",
    organ_placeholder: "Input the key word of organization to query the invoice title.",
    add_tips: "No invoice title is currently selected. Please query and select an invoice title of organization, or ",
    add_ticket: "add a new one.",
    add_organ: "Add New Invoice Title of Organization",
    select_organ: "Choose Invoice Title of Organization",
    close: "Close",
    check: "Select",
    tips: "Please input the key word for searching organization.",
    confirm_add_title: "No qualified organizations have been inquired about.Do you add a header?",
    title_not_sysu: "中山大学 is prohibited for invoice title",
    organ_model: {
      name: "Name",
      taxNumber: "Tax Number",
      address: "Address",
      tele: "Telephone",
      depositBank: "Bank of Deposit",
      bank: "Bank Account",
      name_rule: "Please fill in the text box with name of organization.",
      taxNumber_rule: "Please fill in the text box with tax number of organization.",
    },
  },
  pay_confirm: {
    ticket_info: "Order Information",
    ticketNum: "Order Number",
    money: "Amount",
    paytype: "Methods of Payment",
    please: "Please complete the payment in ",
    please2: "",
    timeformat: "mm minutes and ss seconds",

    tips: "Tips",
    pay_finish: "Payment completed.",
    pay_fail: "Failure to pay",
    pay_canceled: "Payment cancelled ",
    pay_change: "Payment not completed, change the payment method.",
    pay_error: "Problems encountered during payment.",
    pay_cancel: "Cancel the payment order",
    pay_error_title: "Problems arise when payment is made",
    pay_error_tips: `Please record the following information and contact the toll teacher for processing.`,
    pay_error_tips2: `If your account's money is not deducted, you can cancel the order and make a new payment.`,
    close: "Close",
    cancel_repay: "Cancel the order and pay again.",
    timeout_tip: "The order has expired. Please refresh the page and resubmit the order.",
    state: {
      confirm: "OK",
      fresh: "Refresh order",
    },
  },
  choose_fee: {
    range: "Range",
    price: "Unit-Price",
    money: "Amount",
    count: "Quantity",
    maxMoneyMust: "Please enter the amount",
    maxMoneyStart: "Maximum:￥",
    maxMoneyEnd: "(CNY)",
    remark: "Remarks",
    pay: "Go To Pay",
    sum: "Total Amount",
    default_range: "Default Range",
  },
  pay_record: {
    list: {
      code: "Order Number",
      money: "Amount",
      pay_type: "Method of Payment",
      pay_date: "Time of Payment",
      operate: "Operation",
      detail: "Details",
      starttime: "Start Date",
      endtime: "End Date",
      to: "To",
      search: "Search",
    },
    detail: {
      title: "Payment Details",
      pay_info: "Payment Information",
      pay_detail: "Order Details",
      code: "Order Number",
      status: "Order Status",
      money: "Amount",
      create_time: "Create Time",
      pay_type: "Method of Payment",
      pay_time: "Payment Time",
      ticket_title: "Invoice Title",
      close: "Close",
    },
  },
  pay_refund: {
    list: {
      project: "Fee Item",
      range: "Range",
      money: "Amount of refund",
      type: "Refund method",
      date: "Date of refund",
      state: "Refund status",
    },
  },
  message: {
    // 所有的提示信息
    ticketTitle: "Please fill in the information of invoice title.",
  },
  router: {
    pay: {
      unpaid_fee: "To Be Paid",
      choose_fee: "Optional Payments",
      pay_situation: "Payment Conditions",
      refund_record: "Refund Records",
      pay_record: "Payment Histories",
    },
    confirm: {
      pay_ticket: "Payment Confirmation",
      pay_confirm: "Waiting for Payment",
    },
    anonymous: {
      anonymous_pay: "Anonymous Payments",
    },
  },
  success: {
    logout: {
      message: "Are you sure you want to log out?",
      title: "Logout",
      confirmButtonText: "Logout",
      cancelButtonText: "Cancel",
      successMessage: "Successful logout.",
    },
  },
  error: {
    network: "The server is busing, please try again later.",
    logout: {
      message: 'You have been logged out, you can click "Cancel" to stay on the page, or login again.',
      title: " Confirm Logout ",
      confirmButtonText: "Login again ",
      cancelButtonText: "Cancel",
    },
    unknown: "Unknown error, error code: {state}",
    400: "Request error ",
    401: "Unauthorised, please login ",
    403: "Denied access ",
    404: "Request address error: {url}",
    408: "Request timeout ",
    500: "Server internal error ",
    501: "Service not implemented ",
    502: "Gateway error ",
    503: "Service unavailable ",
    504: "Gateway timeout ",
    505: "HTTP version is not supported ",
    6020101: "User name or password error",
  },
};
